<template>
    <div class="products">
        <div class="title">
            <div>Products</div>
            <div class="titleText">产品中心</div>
        </div>
        <div class="productsTips">使高质量的产品和高品质的服务成为我们的价值源泉</div>
        <div class="productsContent">
            <div v-for="(item, index) in list" :key="index" @click="goProduction(item)" style="cursor: pointer;">
                <div>
                    <img src="../assets//img/C-020_ 1_1.png" alt="">
                    <div class="productsContentText">{{ item.text }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            list: [{id:1,text:'水性冷却液系列'},{id:6,text: '油性加工油系列'}, {id:11,text:'防锈清洗剂系列'}, {id:20,text:'工业设备油系列'}, {id:15,text:'复合添加剂系列'}, {id:1,text:'查看全部'}]
        }
    },
    methods: {
        goProduction(row) {
            this.$router.push('/Production?id=' + row.id)
        }
    }
}
</script>
<style scoped>
.products {
    background: #fff;
    padding: 89px 174px;
}

.title {
    margin-left: 15px;
    position: relative;

}

.title::before {
    content: ' ';
    display: block;
    width: 11px;
    height: 121px;
    background: linear-gradient(180deg, #45AFFF 0%, #61FF53 100%);
    border-radius: 0px 0px 0px 0px;
    position: absolute;
    left: -27px;
    top: 11px;
}

.title>div:first-child {
    font-family: PingFang SC, PingFang SC;
    font-weight: 200;
    font-size: 70px;
    color: #373737;
    line-height: 82px;
    text-align: left;
    font-style: normal;
    text-transform: none;
}

.titleText {
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 44px;
    color: #373737;
    line-height: 52px;
    text-align: left;
    font-style: normal;
    text-transform: none;
}

.productsTips {
    margin-top: 37px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 32px;
    color: #6B6B6B;
    line-height: 38px;
    text-align: center;
    font-style: normal;
    text-transform: none;
}

.productsContent {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 76px;

}

.productsContent>div>div:hover {
    transform: scale(1.01);
    background: #C0E4FF;
}

.productsContent>div {
    width: 33.33%;
    text-align: center;
    margin-bottom: 63px;
}

.productsContent>div>div {
    width: 495px;
    height: 604px;
    background: #F6F8FA;
    border-radius: 0px 0px 0px 0px;
    padding-top: 110px;
    margin: auto;

}

.productsContent>div img {
    width: 256px;
    height: 306px;
    margin: auto;
}

.productsContentText {
    margin-top: 63px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 36px;
    color: #373737;
    line-height: 42px;
    font-style: normal;
    text-transform: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Products.vue